module.exports = __webpack_public_path__ + "static/img/baby-lemur.da29329.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/tables/baby-lemur.jpg
// module id = 623
// module chunks = 0